import { render, staticRenderFns } from "./SearchBar.vue?vue&type=template&id=2bf2b24f&scoped=true"
import script from "./SearchBar.vue?vue&type=script&lang=ts"
export * from "./SearchBar.vue?vue&type=script&lang=ts"
import style0 from "./SearchBar.vue?vue&type=style&index=0&id=2bf2b24f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf2b24f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bf2b24f')) {
      api.createRecord('2bf2b24f', component.options)
    } else {
      api.reload('2bf2b24f', component.options)
    }
    module.hot.accept("./SearchBar.vue?vue&type=template&id=2bf2b24f&scoped=true", function () {
      api.rerender('2bf2b24f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/SearchBar.vue"
export default component.exports